/**
 * @file 获取赞的列表
 * @author liudy
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    element_id: number;
}

interface IOutput {
    commit_num: number;
    commit_pictures: number;
    read_num: number;
}

export const getAnalyseInfo = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PHOTO_GET_ANALYSE_INFO, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
